/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as n from "react";
import { FloatingLabel as s } from "@progress/kendo-react-labels";
const a = (e) => {
  const [t, o] = n.useState(!1), r = () => {
    e.current && o(!!e.current.text);
  };
  return n.useEffect(r), {
    editorValue: t
  };
}, l = (e) => {
  const { dateInput: t, ...o } = e, r = a(t);
  return /* @__PURE__ */ n.createElement(
    s,
    {
      ...o,
      ...r
    }
  );
};
export {
  l as PickerFloatingLabel,
  a as usePickerFloatingLabel
};
